import { FeatureToggleClientService } from 'feature-toggle-client';
const isAiAgentsAnalyticsMenuEnabled = 'ai-agents-analytics-menu';
const enableAiAgentNewSettings = 'enable_new_settings_ai_agent';
const aiAgentSkillsEnabled = 'ai-agent-skills-enabled';
const enableAiAgentLongTermMemory = 'ai-agent-long-term-memory';
export class AiAgentsFeatures {
    static isAiAgentsAnalyticsMenuEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isAiAgentsAnalyticsMenuEnabled);
    }
    static isEnableAiAgentNewSettings() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(enableAiAgentNewSettings, false);
    }
    static isAiAgentSkillsEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(aiAgentSkillsEnabled, false);
    }
    static isAiAgentLongTermMemoryEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(enableAiAgentLongTermMemory, false);
    }
}
